// these are collections that we will not enforce looking up by tenant id.

export class DataStoreConstants {
    static NON_TEAM_COLLECTIONS: string[] = [
        "User",
        "Team",
        "UserMembership",
        "Invitation",
        "AccessRequest",
        "NativeAuthentication",
        "SystemAdmin",
    ];
}
